<template>
  <div>
    <el-date-picker
      :type="type"
      v-bind="$attrs"
      v-on="$listeners"
      :value-format="$attrs.valueFormat || $attrs['value-format'] || 'yyyy-MM-dd'"
      :picker-options="pickerOption"
    >
    </el-date-picker>
  </div>
</template>

<script>
export default {
  name: 'ShDatePicker',
  data() {
    return {}
  },
  props: {
    pickerOptions: {
      type: [Boolean, Object],
      default: false
    },
    type: {
      type: String,
      default: 'date'
    }
  },
  computed: {
    pickerOption() {
      if (typeof this.pickerOptions === 'boolean' && this.pickerOptions) {
        if (this.type === 'daterange') {
          return {
            shortcuts: [
              {
                text: '最近两天',
                onClick(picker) {
                  const startDate = new Date()
                  const endDate = new Date()
                  startDate.setTime(startDate.getTime() - 3600 * 1000 * 24 * 2)
                  picker.$emit('pick', [startDate, endDate])
                }
              },
              {
                text: '最近七天',
                onClick(picker) {
                  const end = new Date()
                  const start = new Date()
                  start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
                  picker.$emit('pick', [start, end])
                }
              },
              {
                text: '最近一个月',
                onClick(picker) {
                  const end = new Date()
                  const start = new Date()
                  start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
                  picker.$emit('pick', [start, end])
                }
              },
              {
                text: '最近三个月',
                onClick(picker) {
                  const end = new Date()
                  const start = new Date()
                  start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
                  picker.$emit('pick', [start, end])
                }
              }
            ]
          }
        } else if (this.type === 'date') {
          return {
            shortcuts: [
              {
                text: '今天',
                onClick(picker) {
                  picker.$emit('pick', new Date())
                }
              },
              {
                text: '昨天',
                onClick(picker) {
                  const date = new Date()
                  date.setTime(date.getTime() - 3600 * 1000 * 24)
                  picker.$emit('pick', date)
                }
              },
              {
                text: '一周前',
                onClick(picker) {
                  const date = new Date()
                  date.setTime(date.getTime() - 3600 * 1000 * 24 * 7)
                  picker.$emit('pick', date)
                }
              },
              {
                text: '一月前',
                onClick(picker) {
                  const date = new Date()
                  date.setTime(date.getTime() - 3600 * 1000 * 24 * 30)
                  picker.$emit('pick', date)
                }
              }
            ]
          }
        } else {
          return this.pickerOptions
        }
      } else {
        return this.pickerOptions
      }
    }
  }
}
</script>

<style></style>
